/**
 * Created by marco on 02/09/16.
 */

let cookieManager = {
    // ID for cookie
    cookieName: "CookieManager",
    // value for cookie
    cookieActiveValue: "1",
    // cookie duration
    cookieDuration: 3600 * 24 * 365,
    mostraInformativa: true,
    setCookie: function (cookie_name, cookie_value) {
        let lifespan;
        lifespan = this.cookieDuration;
        return document.cookie = "" + cookie_name + "=" + (encodeURIComponent(cookie_value)) + "; max-age=" + lifespan + "; path=/";
    },
    getCookie: function (cookie_name) {
        let name = cookie_name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1);
            if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
        }
        return false;
    },
    showInformativa: function(){
        if(this.mostraInformativa){
            let cookieVal = this.getCookie(this.cookieName);
            if(!cookieVal || cookieVal != this.cookieActiveValue) {
                document.querySelector('#informativa').classList.remove('hide');
                document.querySelector('#informativaBreve').classList.remove('hide');
                let docCookie = this.setCookie(this.cookieName, this.cookieActiveValue);
            }
        }
    },
    init: function () {
        this.showInformativa();
    }

};


document.addEventListener('DOMContentLoaded', function () {

    let mobileLinks = document.querySelectorAll("nav ul.mobile-menu li a");

    for (let i = 0; i < mobileLinks.length; i++) {

        mobileLinks[i].addEventListener("click", function () {
            document.querySelector('.mobile-menu').classList.add('hide-smaller-large');
        });
    }

    document.querySelector('#hamburger').onclick = function() {
        document.querySelector('.mobile-menu').classList.remove('hide-smaller-large');
    };
    document.querySelector('.close').onclick = function() {
        document.querySelector('.mobile-menu').classList.add('hide-smaller-large');
    };

    //informativa per i cookies
    //links per aprire l'informativa estesa
    let cookieLinks = document.querySelectorAll(".openInformativaEstesa");

    for (let i = 0; i < cookieLinks.length; i++) {
        cookieLinks[i].addEventListener("click", function () {
            document.querySelector('#informativa').classList.remove('hide');
            document.querySelector('#informativaBreve').classList.add('hide');
            document.querySelector('#informativaEstesa').classList.remove('hide');
            document.querySelector('body').classList.add('locked');
        });
    }
    //pulsante di chiusura di entrambe le versioni dell'informativa
    let cookieClose = document.querySelectorAll("#informativa .close");

    for (let i = 0; i < cookieClose.length; i++) {
        cookieClose[i].addEventListener("click", function () {
            document.querySelector('#informativa').classList.add('hide');
            document.querySelector('body').classList.remove('locked');
        });
    }

    //console.log(this.document); // undefined??
    cookieManager.init();

});







